import { render, staticRenderFns } from "./CalloutMessage.partial.vue?vue&type=template&id=18730b8a&scoped=true"
import script from "./CalloutMessage.partial.vue?vue&type=script&lang=js"
export * from "./CalloutMessage.partial.vue?vue&type=script&lang=js"
import style0 from "./CalloutMessage.partial.vue?vue&type=style&index=0&id=18730b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18730b8a",
  null
  
)

export default component.exports